import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

// Images
import Mobile1 from './images/Whofolio_on_mobile_1.png';

class EverydayPeople extends Component {
  render() {
    return (
      <div className="everyday-people">

        <div className="wrap">

          <Fade bottom>
          <img src={Mobile1} alt="whofolio About Me page on a mobile phone" />
          </Fade>

          <Fade right cascade>
          <div className="text-container">
            <h2><strong>whofolio</strong> is for everyday people</h2>
            <h3>Whether you&apos;re a builder, banker, student, designer, or just looking for a job. We&apos;re bridging the gap aiming to connect people from different walks of life.</h3>
          </div>
          </Fade>

        </div>

      </div>
    );
  }
}

export default EverydayPeople;



// WEBPACK FOOTER //
// ./src/assets/components/everydayPeople.js